// src/components/common/RecordNotFoundModal.js
import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, ModalCloseButton,
  Button, VStack, Icon, Text, Heading, useColorModeValue, Code, Box
} from '@chakra-ui/react';
import { MdSearchOff, MdList } from 'react-icons/md';

export default function RecordNotFoundModal({ isOpen, onClose, query, entityName, onClear }) {
  const bgColor = useColorModeValue('white', 'gray.800');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');
  const iconBg = useColorModeValue('gray.100', 'gray.700');

  const handleClear = () => {
    if (onClear) onClear();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent bg={bgColor} borderRadius="xl" p={2} boxShadow="2xl">
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} py={6} textAlign="center">
            <Box p={4} bg={iconBg} borderRadius="full">
              <Icon as={MdSearchOff} boxSize={12} color="gray.500" />
            </Box>
            <Heading size="md">Record Not Found</Heading>
            <Text color={mutedColor} fontSize="sm" px={4}>
              The system could not locate any {entityName} matching the identifier:
            </Text>
            <Code colorScheme="red" p={2} borderRadius="md" w="full" fontSize="sm">
              {query || 'Unknown ID'}
            </Code>
            <Text color={mutedColor} fontSize="xs" mt={2} px={4}>
              This record may have been deleted, archived, or the search ID is incorrect.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="center" borderTopWidth="1px" borderColor={useColorModeValue('gray.100', 'gray.700')}>
          <Button colorScheme="blue" leftIcon={<MdList />} onClick={handleClear} w="full" borderRadius="full">
            View All {entityName}s
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}